import { useLauncherStore } from "../../../../lib/client/contexts/LauncherStoreContext";
import { useSessionContext } from "../contexts/SessionContext";
import { hasViewPermission } from "../utils/hasViewPermission";

export default function useIsMessageHistoryEnabled() {
  const session = useSessionContext().session;
  const config = useLauncherStore((state) => state.config);

  /*
   * Check if the user has permission to view the MessageHistoryCard in the MessagesRoute
   * this will determine if the message history feature is enabled and visible to the user
   */

  return !!config?.routes?.some(
    (route) =>
      route.type === "MessagesRoute" &&
      route.cards?.some(
        (card) =>
          card.card.type === "MessageHistoryCard" &&
          hasViewPermission(session?.user?.usergroupIds || [], card.card),
      ),
  );
}
